import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Layout from 'web/components/Layout';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';
import Featured from './Featured'
import { Helmet } from "react-helmet";
import { searchNearbyNeed, getAllFavoriteAPI } from 'redux/actions/postLoad';
import Pagination from 'web/components/Pagination';
import PalletsSidebar from 'web/components/PalletsSidebar'
import Breadcrumb from "web/components/Breadcrumb";
import styles from './nearByNeed.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

const NearByNeeds = (props) => {
  const token = localStorage.getItem('token');
  let history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [sortState, setSortState] = useState('NEAREST');

  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.searchPostNeed);
  const selectedPageObj = useSelector((state) => state.urlParameters.nearBySelectedPage);

  let selectedPageNo = 1
  if (selectedPageObj?.nearBySelectedPage) {
    selectedPageNo = selectedPageObj?.nearBySelectedPage
  }

  const [currentPage, setCurrentPage] = useState(selectedPageNo);
  const [searchResponse, setSearchResponse] = useState({ payload: [], title: '', totalRecods: '' });

  const [defaulTitle, setDefaulTitle] = useState('');
  const [pageType, setPageType] = useState('');
  const [tabType, setTabType] = useState('');
  const [activePage, setActivePage] = useState();
  const [activeSearch, setActiveSearch] = useState();
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const [expanded, expandedState] = useState();
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      history.push('/sign-in')
      window.location.reload(false);
    } else {
      setCurrentPage(1)
      if (!urlObject) {
        setActiveSearch('PostLoad')
        expandedState('sideBar')
      } else {
        setTabType(urlObject && urlObject.tabType)
        setActiveSearch(urlObject && urlObject.activeSearch)
        expandedState(urlObject && urlObject.expanded)
      }

      let setMiles = ''
      if (setMiles === '' || setMiles === "undefined" || setMiles === undefined || setMiles === null || setMiles === 'null') {
        setMiles = '200'
      }
      if (urlObject?.searchType === "advanceSearch" && localStorage.getItem('advanceSearch') === 'advanceSearch') {
        setDefaulTitle('false')
        handleSearch(localStorage.getItem('advanceSearchObj'), urlObject?.pageType, urlObject?.tabType, urlObject?.params, urlObject?.params, urlObject?.searchType)
      } else {
        if (urlObject && urlObject.params === 'true') {
          let params = 'nearby=' + `${urlObject?.params}` + '&miles=' + setMiles
          handleSearch(params, urlObject?.pageType, urlObject?.tabType, urlObject?.params)
        } else {
          let params;
          if (urlObject && urlObject.title === '') {
            params = 'title=' + `${urlObject?.title}` + '&miles=' + setMiles
          } else {
            if (urlObject?.title)
              params = 'title=' + `${urlObject?.title}`
          }
          if (params === undefined) {
            params = 'title='
          }
          if (urlObject?.params) {
            handleSearch(params, urlObject?.pageType, urlObject?.tabType, urlObject?.params)
          } else {
            if (urlObject) {
              handleSearch(params, 'PostLoad', urlObject?.tabType, urlObject?.params)
            } else {
              handleSearch(params, 'PostLoad', '', 'true')
            }
          }
        }
      }
      localStorage.setItem('titleInput', '')
      if (urlObject && urlObject.title) {
        localStorage.setItem('titleInput', urlObject && urlObject.title)
      }
      if (!urlObject) {
        setPageType('PostLoad')
        setDefaulTitle('true')
      } else {
        setPageType(urlObject && urlObject.pageType)
        setDefaulTitle(urlObject && urlObject.params)
      }

      if (urlObject && !urlObject.activePage) {
        setActivePage("Active")
      } else {
        if (!urlObject) {
          setActivePage("Active")
        } else {
          setActivePage(urlObject && urlObject.activePage)
        }
      }
    }
  }, [urlObject]);

  const handleSearch = async (params, pageType, tabType, nearbyFlag, searchType, postNameTitle) => {
    let currentPage = 1
    let response;

    if (tabType === "WishList") {
      response = await dispatch(getAllFavoriteAPI(currentPage, 12, '', token));
      if (response.status === 'SUCCESS') {
        if (response.payload && response.payload.content) {
          setSearchResponse({ payload: response.payload.content, title: params, totalRecods: response.payload.totalElements })
        }
      } else {
        if (response.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    } else {
      let getParams = new URLSearchParams(urlObject?.params)
      let data = {
        authId: localStorage.getItem('authId'),
        size: 12,
        number: currentPage - 1 || 0,
        sort: "DESC",
        sortBy: "NEAREST",
        searchBy: "",
        miles: getParams?.get("mile") || '',
        isFilter: false,
        filters: null
      };
      if (urlObject?.title && localStorage.getItem('advanceSearch') === 'SEARCH_BY') { // searching from dashboard
        data = {
          ...data,
          searchBy: urlObject?.title || '',
        };
      } else if (localStorage.getItem('advanceSearch') === 'advanceSearch') { // searching from advance search option
        data = {
          ...data,
          isFilter: true,
          filters: {
            city: getParams?.get("city") || '',
            state: getParams?.get("state") || '',
            palletSize: getParams?.get("size") || '',
            grade: getParams?.get("grade") || ''
          }
        };
      }
      response = await dispatch(searchNearbyNeed(data, token));
      if (response.success) {
        if (response.data.nearBySearch) {
          setSearchResponse({ payload: response.data.nearBySearch, title: params, totalRecods: response.data?.totalElements })
        }
      } else {
        if (response.statusCode === 409) {
          setSearchResponse({ payload: [], title: '', totalRecods: '' })
        } else if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  const onChangeHandler = (val, type) => {
    searchApi(searchResponse.title, currentPage, val, type)
  }

  const onWishListChangeHandler = async (val) => {
    let response = await dispatch(getAllFavoriteAPI(1, 12, '', token));
    if (response.status === 'SUCCESS') {
      if (response.payload && response.payload.content) {
        setSearchResponse({ payload: response.payload.content, title: defaulTitle, totalRecods: response.payload.totalElements })
      }
    } else {
      if (response.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  const searchApi = async (title, pageNumber, sort, type) => {
    let response;
    let getParams = new URLSearchParams(urlObject?.params)
    let data = {
      authId: localStorage.getItem('authId'),
      size: 12,
      number: pageNumber - 1 || 0,
      sort: "DESC",
      sortBy: sort,
      searchBy: "",
      miles: getParams?.get("mile") || '',
      isFilter: false,
      filters: null
    };
    if (urlObject?.title && localStorage.getItem('advanceSearch') === 'SEARCH_BY') {
      data.searchBy = urlObject?.title || '';
    } else if (localStorage.getItem('advanceSearch') === 'advanceSearch') {
      data = {
        ...data,
        isFilter: true,
        filters: {
          city: getParams?.get("city") || '',
          state: getParams?.get("state") || '',
          palletSize: getParams?.get("size") || '',
          grade: getParams?.get("grade") || ''
        }
      };
    }
    response = await dispatch(searchNearbyNeed(data, token));
    if (response.success) {
      if (response.data.nearBySearch) {
        setSearchResponse({ payload: response.data.nearBySearch, title: title, totalRecods: response.data?.totalElements });
      }
    } else {
      if (response.statusCode === 409) {
        setSearchResponse({ payload: [], title: '', totalRecods: '' })
      } else if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink('');
        toggleModal();
      }
    }
  }
  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
    let obj = {
      nearBySelectedPage: pageNumber,
    }

    dispatch({ type: 'NEARBY_PAGINATION', payload: obj })
    if (urlObject?.searchType === "advanceSearch") {
      searchApi(searchResponse.title, pageNumber, sortState, urlObject?.params, urlObject.searchType)
    } else {
      searchApi(searchResponse.title, pageNumber, sortState)
    }

  }
  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
    },
  ];
  let selectedPage = tabType;
  if (!selectedPage) {
    selectedPage = pageType;
  }

  selectedPage = pageLanguageContents?.Breadcrumb[1]?.PalletNeeds

  let dropDownArr = []
  dropDownArr.push({
    id: "0",
    label: 'PostLoad',
    value: "PostLoad",
  });
  return (
    <>
      <Helmet title="Locate Nearby Pallet Needs | PalletTrader" >
        <meta name="description"
          content="Identify and connect with previously unknown nearby pallet buyers. Efficiently manage your pallet inventory. Bid every day, or bid automatically, daily or weekly." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/nearby-needs" />
      </Helmet>
      {pageType && (
        <Layout
          userType="Buyer"
          selectedSearch='PostLoad'
          tabType={tabType}
          searchTitle=''
        >
          {loaderVisible && <Spinner />}
          <div className={styles.homeWrapper}>
            <div className={styles.wrapper}>
              <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected={selectedPage}
                title=""
              />
              {pageType !== "" && (
                <div className={styles.section}>
                  <div className="pd-right-nav">
                    {activePage && <PalletsSidebar expandedPallet={'panel2'} activePage={activePage} activeSearch={activeSearch} postType={'searchNeedSideBar'} />}
                  </div>
                  <Featured
                    totalRecord={searchResponse.totalRecods}
                    outOf={12}
                    pageType={pageType}
                    response={searchResponse.payload}
                    title=""
                    currentPage={currentPage}
                    tabType={tabType}
                    onChangeHandler={(val) => {
                      setSortState(val)
                      onChangeHandler(val, "sorting");
                    }}
                    onWishListChangeHandler={(val) => {
                      setPageType(val)
                      onWishListChangeHandler(val);
                    }}
                  />
                </div>
              )}
              {searchResponse.payload.length !== 0 &&
                searchResponse.totalRecods && (
                  <Pagination
                    currentPage={currentPage}
                    totalPage={searchResponse.totalRecods}
                    itemsCountPerPage={12}
                    onPageChange={(value) => {
                      onPageChange(value);
                    }}
                  />
                )}
            </div>
          </div>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
          />
        </Layout>
      )}
    </>
  );
}
export default NearByNeeds;